import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PlansCardsComponent } from './plans-cards/plans-cards.component';
import { PLANS } from '@app/utils/constants/plans.constants';
import { SubscriptionUnit } from '@app/utils/interfaces/plans.interface';

@Component({
  selector: 'app-plans-banner',
  standalone: true,
  imports: [TranslateModule, PlansCardsComponent],
  templateUrl: './plans-banner.component.html',
  styleUrl: './plans-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlansBannerComponent {
  public plans = signal<SubscriptionUnit[]>(PLANS);
}
